/**
 * Format an axios error so toasts surface the real cause instead of a
 * generic fallback string. Order of preference:
 *   1. Backend's HTTPException detail (string or JSON-stringified object).
 *   2. HTTP status code (e.g. "approve failed (HTTP 502)").
 *   3. Native error message (e.g. "Network Error").
 *   4. The caller's fallback label.
 */
export function formatApiError(err, fallback = "Request failed") {
  const detail = err?.response?.data?.detail;
  if (detail) {
    return typeof detail === "string" ? detail : JSON.stringify(detail);
  }
  const status = err?.response?.status;
  if (status) return `${fallback} (HTTP ${status})`;
  return err?.message || fallback;
}
